import React, { useState, useEffect, useRef } from 'react';
import { Avatar, Button, Chip } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';

import '../style/Main.scss';

import java from '../assets/logos/JavaLogo.png';
import html from '../assets/logos/HTMLLogo.png';
import css from "../assets/logos/CSSLOGO.png";
import js from "../assets/logos/JSLogo.png";
import jquery from "../assets/logos/jQueryLogo.png";
import reactjs from "../assets/logos/ReactLogo.png";
import spring from "../assets/logos/SpringLogo.png";
import springboot from "../assets/logos/springbootlogo.png";
import sass from "../assets/logos/SassLogo.png";
import docker from "../assets/logos/docker.png";
import kubernetes from "../assets/logos/Kubernetes.png";
import myImage from '../assets/AD.jpeg';
import onlinebankportal from "../assets/images/OnlineBankPortalDashboard.png";
import rmanage from "../assets/images/RManageDashboard.png";
import mongodb from "../assets/logos/mongodb.png";
import springData from "../assets/logos/springData.png";
import springSecurity from "../assets/logos/springSecurity.png";
import sql from "../assets/logos/sql.png";
import taskify from "../assets/images/Taskify.png";
import trafficer from "../assets/images/TRAFFICER.png";
import node from "../assets/logos/nodejslogo.png";
import express from "../assets/logos/express.png";
import nest from "../assets/logos/nestjs.png";
import ts from "../assets/logos/typescript.png";

import Intro from './Intro';
import About from './About';
import Experience from './Experience';
import Projects from './Projects';
import Footer from './Footer';
import ScrollToTopButton from './ScrollToTopButton';

//const cvUrl = '#';
const emailUrl = "mailto:er.ayandhiman@gmail.com";
const linkedinUrl = "https://www.linkedin.com/in/ayan-dhiman/";
const githubUrl = "https://github.com/ayan-dhiman";
const taskifyUrl = "https://taskifyz.vercel.app/";

export {
  React,
  useState,
  useEffect,
  useRef,
  Avatar,
  Button,
  Chip,
  LinkedInIcon,
  GitHubIcon,
  java,
  html,
  css,
  js,
  jquery,
  reactjs,
  spring,
  springboot,
  sass,
  docker,
  kubernetes,
  myImage,
  onlinebankportal,
  rmanage,
  emailUrl,
  linkedinUrl,
  githubUrl,
  Intro,
  About,
  Experience,
  Projects,
  Footer,
  ScrollToTopButton,
  springData,
  springSecurity,
  sql,
  mongodb,
  taskify,
  taskifyUrl,
  trafficer,
  node,
  nest,
  express,
  ts
};
